import Address from "./Address";
import UserInfo from "./UserInfo";

class Agent {
  constructor(data) {
    if (data) {
      this.AgentId = data.AgentId;
      this.userInfo = new UserInfo(data.User);
      this.address = new Address(data.address);
      this.BusinessName = data.BusinessName;
      this.BusinessAddress = data.BusinessAddress;
      this.ReligionsServe = data.ReligionsServe;
      this.CastesServe= data.CastesServe;
      this.CommunitesServe= data.CommunitesServe;
      this.Rateings= data.Rateings;
      this.LanguagesServe= data.LanguagesServe;
    } else {
      this.userInfo = new UserInfo();
      this.address = new Address();
      this.BusinessName = null;
      this.BusinessAddress = null;
      this.BusinessDescription=null;
      this.ReligionsServe=[];
      this.CastesServe=[];
      this.CommunitesServe=[];
      this.Rateings=5;
      this.LanguagesServe = [];
    }
  }
}

export default Agent;
